import { defineAction } from '~/prix'
import residenceImageUpdateAction from './residenceImageUpdate.action.json' with { type: 'json' }
import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'

const residenceImageUpdateDefinition = defineAction({
  ...residenceImageUpdateAction,

  input: z.object({
    id: z.string().uuid(),
    description: z.string().nullish(),
    position: z.number(),
    updatedAt: dateOrIsoString().nullish(),
  }),
  output: z.object({}),
})

export default residenceImageUpdateDefinition
